import { render, staticRenderFns } from "./Dashboards_115.vue?vue&type=template&id=810c79be&scoped=true&"
import script from "./Dashboards_115.vue?vue&type=script&lang=js&"
export * from "./Dashboards_115.vue?vue&type=script&lang=js&"
import style0 from "./Dashboards_115.vue?vue&type=style&index=0&id=810c79be&prod&lang=scss&"
import style1 from "./Dashboards_115.vue?vue&type=style&index=1&id=810c79be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c79be",
  null
  
)

export default component.exports